import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './InformationOrderBlock.module.scss';
import { dateForOrderDetails } from 'utils/date';
import { ResponseGetOrderType } from 'redux/Api/ordersApi/type';
interface DealOrderBlockTypes {
  objectInfo?: ResponseGetOrderType['deal'] | null;
  className?: string;
}

export const DealOrderBlock: FC<DealOrderBlockTypes> = ({ objectInfo, className }) => {
  const objectElements = [];

  const translateObj: Record<string, string> = {
    status: 'Статус',
    tochka_created_at: 'Дата создания',
    tochka_updated_at: 'Дата обновления',
    tochka_uuid: 'UUID',
  };

  if (!objectInfo) {
    return <div>{'Нет сделки'}</div>;
  }

  for (const key in objectInfo) {
    if (Object.prototype.hasOwnProperty.call(objectInfo, key) && key in translateObj) {
      objectElements.push(
        <div className={styles.blockDetail} key={key}>
          <p className={styles.blockDetail_key}>{translateObj[key]} </p>
          <p className={styles.blockDetail_value}>
            {key.includes('tochka_created_at') || key.includes('tochka_updated_at')
              ? dateForOrderDetails(String(objectInfo[key as keyof typeof objectInfo]))
              : objectInfo[key as keyof typeof objectInfo]}
          </p>
        </div>,
      );
    }
  }

  return (
    <div className={classNames(styles.blockDetailRoot, className)}>{objectElements}</div>
  );
};
